export const manualInvoiceModal = {
  modalTitle: {
    create: "Criar fatura manualmente",
    correcting: "Corrigir dados da fatura",
  },
  confirm: {
    title: "Revise antes de criar",
    subtitle:
      "Um rascunho será criado. Você pode revisá-lo, adicionar cobranças e emiti-lo quando quiser.",
    rowDocument: "Documento",
    documentValue: "Rascunho · número na emissão",
    rowType: "Tipo",
    typeCompany: "Empresa / Pessoa jurídica",
    typeIndividual: "Pessoa física",
    labelCompanyName: "Razão social",
    labelName: "Nome",
    rowCountry: "País",
    rowEmail: "E-mail",
    rowAddress: "Endereço",
    rowPayment: "Pagamento",
    rowNotes: "Observações",
  },
  info: {
    createTitle: "Uma fatura em RASCUNHO será criada (sem número até ser emitida).",
    correctingTitle: "Corrigindo dados fiscais",
    createBody:
      "Será salva como rascunho. Você pode adicionar cobranças e, quando estiver pronta, emiti-la — o número sequencial é atribuído pela autoridade fiscal na emissão.",
    correctingBody:
      "Altere apenas os dados que precisa corrigir. Uma <strong>fatura corretiva</strong> será gerada com os dados corretos.",
  },
  prefillLoading: "Carregando os dados fiscais do hóspede…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Esta reserva tem vários quartos. Que fatura quer criar?",
    continue: "Continuar",
    label: "Como quer faturar?",
    whole: "A reserva inteira",
    wholeHint: "Uma única fatura com os {n} quartos.",
    perRoom: "Um quarto",
    perRoomHint: "Cada quarto, a sua fatura: as suas noites e os seus encargos.",
    pickRoom: "Escolha o quarto",
    repeatHint: "Repita para cada quarto para que cada hóspede tenha a sua.",
  },

  recipientType: {
    label: "Tipo de destinatário",
    individual: "Pessoa física",
    individualSub: "Pessoa natural",
    company: "Empresa",
    companySub: "Pessoa jurídica",
    active: "Ativo",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Cliente salvo",
    help: "Busque um cliente do cadastro e os dados fiscais são preenchidos sozinhos. Se não estiver, digite os dados manualmente.",
    clear: "Remover",
    linkedHint: "Dados vindos do cadastro do cliente. Você pode corrigir qualquer campo sem perder o vínculo com o cliente.",
    noFiscalProfile: "Esse cliente não tem perfil de faturamento salvo: trouxemos o nome e o e-mail, o resto precisa ser digitado (ou complete o cadastro dele em Clientes).",
  },
  fields: {
    nameCompany: "Razão social *",
    nameIndividual: "Nome completo *",
    country: "País",
    countryPlaceholder: "Selecione o país do hóspede",
    countryHint: "Informe o país fiscal do hóspede para a fatura.",
    optional: "(opcional)",
    emailLabel: "E-mail de faturamento",
    phoneLabel: "Telefone",
    addressLabel: "Endereço fiscal",
    sectionInvoiceData: "Dados da fatura",
    paymentSourceLabel: "Origem do pagamento",
    paymentHintPrefilled:
      "Marcado com base nos pagamentos que você registrou. Altere se não estiver correto.",
    paymentHintMulti:
      "Você pode marcar vários se a estadia foi paga de mais de uma forma.",
    paymentHintNone: "Se nada for marcado, a fatura não indicará como foi paga.",
    seriesLabel: "Série",
    seriesHint: "Esta série vem das suas configurações de faturamento.",
    notesLabel: "Dados adicionais da fatura",
    notesHint:
      "Use para adicionar um item de texto livre, esclarecimentos ou detalhes extras de emissão.",
  },
  preview: {
    label: "Próximo número sequencial",
    estHint: "para referência · atribuído na emissão (o primeiro a emitir fica com ele)",
    noNumber: "Atribuído na emissão · o rascunho não tem número",
  },
  footer: {
    cancel: "Cancelar",
    create: "Criar fatura",
    editData: "Editar dados",
    creating: "Criando...",
    createDraft: "Criar rascunho",
  },
  success: {
    title: "Fatura emitida!",
    badge: "Emitida",
    pdfGenerating: "O PDF está sendo gerado. Pode levar alguns segundos.",
    downloadPdf: "Baixar fatura em PDF",
    generatingPdf: "Gerando PDF…",
    sendWhatsapp: "Enviar pelo WhatsApp",
    closeWindow: "Fechar janela",
  },
  paymentSource: {
    cash: "Dinheiro",
    card: "Cartão de crédito",
    transfer: "Transferência bancária",
    otherOta: "Pago por outra OTA",
  },
  prefill: {
    clientFile:
      "Dados vindos do cadastro do cliente. Revise-os antes de criar o rascunho.",
    invoiceRecipient: "Dados pré-carregados da última fatura do hóspede.",
    chat: "Dados fiscais que o hóspede forneceu ao solicitar a fatura. Revise-os e emita.",
    checkin:
      "Pré-carregamos o nome e o e-mail do hóspede a partir do check-in. Complete os dados fiscais abaixo.",
    reservation:
      "Não havia dados fiscais completos; os dados básicos da reserva são usados como base.",
    existingInvoice:
      "Dados pré-carregados da fatura existente. Altere o que precisar corrigir.",
  },
  status: {
    sent: "Emitida",
    processing: "Processando",
    pending: "Pendente",
    error: "Erro",
  },
  toast: {
    whatsappSent: "Fatura enviada pelo WhatsApp.",
    whatsappError: "Não foi possível enviar a fatura pelo WhatsApp.",
    draftCreated: "Rascunho criado. Revise-o e emita quando estiver pronto.",
  },
  validation: {
    nameRequired: "O nome ou a razão social é obrigatório.",
    countryInvalid: "Selecione um país válido.",
    emailInvalid: "Informe um e-mail válido.",
    taxIdRequired: "Este documento fiscal é obrigatório para este tipo de destinatário.",
  },
  errors: {
    conflict: "A reserva já tem uma fatura criada.",
    checkData: "Verifique os dados de faturamento.",
    createFailed: "Não foi possível criar a fatura.",
  },
  taxId: {
    labels: {
      esCompany: "NIF da empresa",
      brIndividual: "CPF ou RG",
      defaultIndividual: "Número de identificação fiscal",
      defaultCompany: "Número fiscal",
    },
    hints: {
      esIndividual: "DNI ou NIE (X1234567A). O passaporte não é um documento fiscal válido.",
      esCompany: "NIF/CIF da empresa.",
      ptIndividual: "9 dígitos.",
      ptCompany: "9 dígitos.",
      coIndividual: "6-10 dígitos.",
      coCompany: "NIT com dígito verificador.",
      mxIndividual: "RFC para pessoa física.",
      mxCompany: "RFC para pessoa jurídica.",
      arIndividual: "11 dígitos com dígito verificador.",
      arCompany: "11 dígitos com dígito verificador.",
      clIndividual: "Com dígito verificador.",
      clCompany: "Com dígito verificador.",
      peIndividual: "8 dígitos.",
      peCompany: "11 dígitos.",
      ecIndividual: "10 dígitos.",
      ecCompany: "13 dígitos.",
      brIndividual:
        "CPF válido para emissão fiscal. Se você informar um RG, ele será salvo como o documento local do hóspede.",
      brCompany: "14 dígitos.",
      defaultIndividual: "Opcional.",
      defaultCompany: "Obrigatório para empresas.",
    },
  },
  address: {
    ES: { city: "Cidade", state: "Província", zip: "Código postal" },
    PT: { city: "Cidade", state: "Distrito", zip: "Código postal" },
    CO: { city: "Cidade", state: "Depto.", zip: "Código postal" },
    MX: { city: "Cidade", state: "Estado", zip: "Código postal" },
    AR: { city: "Cidade", state: "Província", zip: "Código postal" },
    CL: { city: "Cidade", state: "Região", zip: "Código postal" },
    BR: { city: "Cidade", state: "Estado", zip: "CEP" },
    US: { city: "Cidade", state: "Estado", zip: "ZIP" },
    GB: { city: "Cidade", state: "Condado", zip: "Código postal" },
    DEFAULT: { city: "Cidade", state: "Região", zip: "Código postal" },
  },
  taxErrors: {
    cifCompany: "NIF/CIF da empresa inválido.",
    esIndividual: "Documento inválido. Informe um DNI, NIE (X1234567A) ou passaporte.",
    ptNif: "NIF inválido. Deve ter 9 dígitos válidos.",
    nit: "NIT inválido.",
    coCedula: "Cédula inválida. Entre 6 e 10 dígitos.",
    rfc: "RFC inválido.",
    cuit: "CUIT inválido.",
    cuilCuit: "CUIL/CUIT inválido.",
    rut: "RUT inválido.",
    ruc: "RUC inválido.",
    peDni: "DNI inválido. Deve ter 8 dígitos.",
    ecCedula: "Cédula inválida.",
    cnpj: "CNPJ inválido.",
    brIndividual: "Documento inválido. Use um CPF válido ou um RG no formato usual.",
  },
};
